import { memo } from 'react';
import {
  MainSection,
  TeamOfProfessionals,
  WhoWeAre,
  AboutUs,
  OnlineBusinessConsulting,
  GetInTouchForm
} from '../../components';
import {
  MAIN_SECTION_ID,
  TEAM_OF_PROFESSIONALS_ID,
  WHO_WE_ARE_ID,
  ABOUT_US_ID,
  ONLINE_BUSINESS_CONSULTING_ID,
  GET_IN_TOUCH_FORM_ID
} from '../../utils';
import bgImage from '../../assets/images/bg-main-image.png';
import "./LandingPage.scss";

const MemoComponent = () => {
  return (
    <div className="landing-page display-flex-column">
      <img src={bgImage} className="bg-z-image"/>
      <MainSection id={MAIN_SECTION_ID}/>
      <TeamOfProfessionals id={TEAM_OF_PROFESSIONALS_ID}/>
      <WhoWeAre id={WHO_WE_ARE_ID}/>
      <AboutUs id={ABOUT_US_ID}/>
      <OnlineBusinessConsulting id={ONLINE_BUSINESS_CONSULTING_ID}/>
      <GetInTouchForm id={GET_IN_TOUCH_FORM_ID}/>
    </div>
  )
};

export const LandingPage = memo(MemoComponent);